import { useState } from 'react';
import { useAppDispatch, useAppSelector } from '../Core/hooks'
import { joinWaitlist } from '../Store/Utility';
//import { Link } from 'react-router-dom';
import { CSSProperties } from "react";
import { IoMdCheckmarkCircleOutline } from "react-icons/io";
import { isValidEmail } from '../Helpers/isValidEmail';
import { Link, useNavigate } from 'react-router-dom';
import { getStripe } from '../Store/Stripe';

interface Props {
    mostPopularButtonBorder: string;   
    mostPopularButtonColor: string;
    mostPopularButtonBackgroundColor: string; 
    page: string;
}

function PricingTiers(props: Props) {

    const dispatch = useAppDispatch();
    const stripeState = useAppSelector(getStripe);
    let [starterEmail, setStarterEmail] = useState<string>("");
    let [essentialsEmail, setEssentialsEmail] = useState<string>("");
    let [teamsEmail, setTeamsEmail] = useState<string>("");
    const [starterError, setStarterError] = useState<boolean>(false);
    const [starterSuccess, setStarterSuccess] = useState<boolean>(false);
    const [essentialsError, setEssentialsError] = useState<boolean>(false);
    const [essentialsSuccess, setEssentialsSuccess] = useState<boolean>(false);
    const [teamsError, setTeamsError] = useState<boolean>(false);
    const [teamsSuccess, setTeamsSuccess] = useState<boolean>(false);
    const navigate = useNavigate();

    let mostPopularStyle: CSSProperties = {
        width: "70%", 
        backgroundColor: props.mostPopularButtonBackgroundColor, 
        padding: "15px", 
        borderRadius: "30px", 
        border: props.mostPopularButtonBorder, 
        color: props.mostPopularButtonColor, 
        fontWeight: "400", 
        fontSize: "14pt", 
        textAlign: "center"
    }

    const handleEmailChangeStarter = (e: React.ChangeEvent<HTMLInputElement>) => {
        setStarterEmail(e.target.value);
    }
    const handleEmailChangeEssentials = (e: React.ChangeEvent<HTMLInputElement>) => {
        setEssentialsEmail(e.target.value);
    }
    const handleEmailChangeTeams = (e: React.ChangeEvent<HTMLInputElement>) => {
        setTeamsEmail(e.target.value);
    }
    const handleJoinStarterWaitlist = (e: React.MouseEvent<HTMLButtonElement> | React.KeyboardEvent<HTMLButtonElement>) => {
        
        e.preventDefault();

        if (e.type === "keydown" ) {
            let keypress = e as React.KeyboardEvent;
            if (keypress.key !== 'Enter') {
                return;
            }            
        }
        
        if (isValidEmail(starterEmail)) {
            setStarterSuccess(true);
            setTimeout(() => setStarterSuccess(false), 2000);
            addToWaitlist("starter", starterEmail);
        } else {
            setStarterError(true);
            setTimeout(() => setStarterError(false), 2000);
        }
    }
    const handleJoinEssentialsWaitlist = (e: React.MouseEvent<HTMLButtonElement> | React.KeyboardEvent<HTMLButtonElement>) => {
        
        e.preventDefault();

        if (e.type === "keydown" ) {
            let keypress = e as React.KeyboardEvent;
            if (keypress.key !== 'Enter') {
                return;
            }            
        }
        
        if (isValidEmail(essentialsEmail)) {
            setEssentialsSuccess(true);
            setTimeout(() => setEssentialsSuccess(false), 2000);
            addToWaitlist("essentials", essentialsEmail);
        } else {
            setEssentialsError(true);
            setTimeout(() => setEssentialsError(false), 2000);
        }
    }
    const handleJoinTeamsWaitlist = (e: React.MouseEvent<HTMLButtonElement> | React.KeyboardEvent<HTMLButtonElement>) => {
        
        e.preventDefault();

        if (e.type === "keydown" ) {
            let keypress = e as React.KeyboardEvent;
            if (keypress.key !== 'Enter') {
                return;
            }            
        }
        
        if (isValidEmail(teamsEmail)) {
            setTeamsSuccess(true);
            setTimeout(() => setTeamsSuccess(false), 2000);
            addToWaitlist("teams", teamsEmail);
        } else {
            setTeamsError(true);
            setTimeout(() => setTeamsError(false), 2000);
        }
    }

    const addToWaitlist = (pricingPackage: string, email: string) => {

        dispatch(joinWaitlist({
            firstName: "",
            lastName: "",
            email: email,
            marketingSource: "pricing package: " + pricingPackage
        }));

        setStarterEmail("");
        setEssentialsEmail("");
        setTeamsEmail("");
    }

    const handleRegister = (e: React.MouseEvent<HTMLButtonElement> | React.KeyboardEvent<HTMLButtonElement>, pricingPackage: string) => {
        navigate("/register/" + pricingPackage + "/" + props.page);
    }
    //console.log(stripeState);
    if (stripeState.plans.length === 0) {
        return <div>Loading...</div>
    } else {

        let plan1 = stripeState.plans.find(p => p.sort === 0);
        let plan2 = stripeState.plans.find(p => p.sort === 1);
        let plan3 = stripeState.plans.find(p => p.sort === 2);

        if (plan1 && plan2 && plan3) {
            return (
            <div className="pricingTierBox">




                <div className="pricingStarterBox"> 
                    <div style={{ width: "90%", margin: "0px auto" }}>
                        <div className="pricingStarterTitle">
                            Solo
                        </div>
                        <div style={{ textAlign: "left", marginLeft: "10px", marginTop: "10px", color: "#495866", fontWeight: "400" }}>
                            Ideal for soloprenuers needing to plan and manage their work.
                        </div>
                        <div style={{ width: "100%", display: "flex", alignItems: "center" }}>
                            <div style={{ textAlign: "left", marginLeft: "10px", fontSize: "32pt", fontWeight: "bold" }}>
                                $0
                            </div>
                            <div style={{ fontSize: ".8em", textAlign: "left", marginLeft: "10px", color: "#495866", fontWeight: "400" }}>
                                Free Forever
                            </div>
                        </div>
                        <button className="blueButton" onClick={(e) => handleRegister(e, "starter")} onKeyDown={(e) => handleRegister(e, "starter")}>
                            Sign up
                        </button> 
                        <hr className="pricingDivider" />
                        <div style={{ textAlign: "left" }}>
                            <div style={{ marginBottom: "10px" }}>
                                <div style={{ display: "inline-block", marginRight: "10px" }}>
                                    <IoMdCheckmarkCircleOutline size={20} />
                                </div>
                                <div style={{ position: "relative", top: "2px", fontSize: "13pt", display: "inline-block" }}>
                                    2 Roadmaps
                                </div>
                            </div>
                            <div style={{ marginBottom: "10px" }}>
                                <div style={{ display: "inline-block", marginRight: "10px" }}>
                                    <IoMdCheckmarkCircleOutline size={20} />
                                </div>
                                <div style={{ position: "relative", top: "2px", fontSize: "13pt", display: "inline-block" }}>
                                    Unlimited Projects
                                </div>
                            </div>
                            <div style={{ marginBottom: "10px" }}>
                                <div style={{ display: "inline-block", marginRight: "10px", fontSize: "13pt" }}>
                                    <IoMdCheckmarkCircleOutline size={20} /> Collaborate and chat on roadmaps shared with you 
                                    <i>(sharing not included)</i>
                                </div>
                                <div style={{ position: "relative", top: "2px", fontSize: "13pt", display: "inline-block" }}>
                                    
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                








 
                
                <div className="pricingEssentialsBox"> 
                    <div className="pricingEssentialsBoxAdjustment">
                        <div style={mostPopularStyle}>
                            Most Popular
                        </div>
                    </div>
                    <div style={{ width: "90%", margin: "0px auto" }}>
                        <div className="pricingEssentialsTitle">
                            {plan1.name}
                        </div>
                        <div style={{ textAlign: "left", marginLeft: "10px", marginTop: "10px", color: "#495866", fontWeight: "400" }}>
                            {plan1.description}
                        </div>
                        <div style={{ width: "100%", display: "flex", alignItems: "center" }}>
                            <div style={{ textAlign: "left", marginLeft: "10px", fontSize: "32pt", fontWeight: "bold" }}>
                                ${plan1.price}
                            </div>
                            <div style={{ fontSize: ".8em", textAlign: "left", marginLeft: "10px", color: "#495866", fontWeight: "400" }}>
                                {plan1.billingCycle === 1 && "Per user, per month, billed monthly" }
                            </div>
                        </div>
                        <button className="blueButton" onClick={(e) => handleRegister(e, "essentials")} onKeyDown={(e) => handleRegister(e, "essentials")}>
                            Try for free
                        </button> 
                        <hr className="pricingDivider" />
                        <div style={{ textAlign: "left" }}>
                            <div style={{ marginBottom: "10px" }}>
                                <div style={{ display: "inline-block", marginRight: "10px" }}>
                                    <IoMdCheckmarkCircleOutline size={20} />
                                </div>
                                <div style={{ position: "relative", top: "2px", fontSize: "13pt", display: "inline-block" }}>
                                    {plan1.features[0]}
                                </div>
                            </div>
                            <div style={{ marginBottom: "10px" }}>
                                <div style={{ display: "inline-block", marginRight: "10px" }}>
                                    <IoMdCheckmarkCircleOutline size={20} />
                                </div>
                                <div style={{ position: "relative", top: "2px", fontSize: "13pt", display: "inline-block" }}>
                                    {plan1.features[1]}
                                </div>
                            </div>
                            <div style={{ marginBottom: "10px" }}>
                                <div style={{ display: "inline-block", marginRight: "10px" }}>
                                    <IoMdCheckmarkCircleOutline size={20} />
                                </div>
                                <div style={{ position: "relative", top: "2px", fontSize: "13pt", display: "inline-block" }}>
                                    {plan1.features[2]}
                                </div>
                            </div>
                            <div style={{ marginBottom: "10px" }}>
                                <div style={{ display: "inline-block", marginRight: "10px" }}>
                                    <IoMdCheckmarkCircleOutline size={20} />
                                </div>
                                <div style={{ position: "relative", top: "2px", fontSize: "13pt", display: "inline-block" }}>
                                    {plan1.features[3]}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>





                <div className="pricingStarterBox"> 
                    <div style={{ width: "90%", margin: "0px auto" }}>
                        <div className="pricingStarterTitle">
                            {plan2.name}
                        </div>
                        <div style={{ textAlign: "left", marginLeft: "10px", marginTop: "10px", color: "#495866", fontWeight: "400" }}>
                            {plan2.description}
                        </div>
                        <div style={{ width: "100%", display: "flex", alignItems: "center" }}>
                            <div style={{ textAlign: "left", marginLeft: "10px", fontSize: "32pt", fontWeight: "bold" }}>
                                ${plan2.price}
                            </div>
                            <div style={{ fontSize: ".8em", textAlign: "left", marginLeft: "10px", color: "#495866", fontWeight: "400" }}>
                                {plan2.billingCycle === 1 && "Per user, per month, billed monthly" }
                            </div>
                        </div>
                        <button className="blueButton" onClick={(e) => handleRegister(e, "starter")} onKeyDown={(e) => handleRegister(e, "starter")}>
                            Try for free
                        </button> 
                        <hr className="pricingDivider" />
                        <div style={{ textAlign: "left" }}>
                            <div style={{ marginBottom: "10px" }}>
                                <div style={{ display: "inline-block", marginRight: "10px" }}>
                                    <IoMdCheckmarkCircleOutline size={20} />
                                </div>
                                <div style={{ position: "relative", top: "2px", fontSize: "13pt", display: "inline-block" }}>
                                    {plan2.features[0]}
                                </div>
                            </div>
                            <div style={{ marginBottom: "10px" }}>
                                <div style={{ display: "inline-block", marginRight: "10px" }}>
                                    <IoMdCheckmarkCircleOutline size={20} />
                                </div>
                                <div style={{ position: "relative", top: "2px", fontSize: "13pt", display: "inline-block" }}>
                                    {plan2.features[1]} 
                                </div>
                            </div>
                            <div style={{ marginBottom: "10px" }}>
                                <div style={{ display: "inline-block", marginRight: "10px" }}>
                                    <IoMdCheckmarkCircleOutline size={20} />
                                </div>
                                <div style={{ position: "relative", top: "2px", fontSize: "13pt", display: "inline-block" }}>
                                    {plan2.features[2]}
                                </div>
                            </div>
                            <div style={{ marginBottom: "10px" }}>
                                <div style={{ display: "inline-block", marginRight: "10px" }}>
                                    <IoMdCheckmarkCircleOutline size={20} />
                                </div>
                                <div style={{ position: "relative", top: "2px", fontSize: "13pt", display: "inline-block" }}>
                                    {plan2.features[3]}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>








                {/*
                <div className="pricingTeamsBox"> 
                    <div style={{ width: "90%", margin: "0px auto" }}>
                        <div className="pricingTeamsTitle">
                            {plan3.name}
                        </div>
                        <div style={{ textAlign: "left", marginLeft: "10px", marginTop: "10px", color: "#495866", fontWeight: "400" }}>
                            {plan3.description}
                        </div>
                        <div style={{ width: "100%", display: "flex", alignItems: "center" }}>
                            <div style={{ textAlign: "left", marginLeft: "10px", fontSize: "32pt", fontWeight: "bold" }}>
                                ${plan3.price}
                            </div>
                            <div style={{ fontSize: ".8em", textAlign: "left", marginLeft: "10px", color: "#495866", fontWeight: "400" }}>
                                {plan3.billingCycle === 1 && "Per user, per month, billed monthly" }
                            </div>
                        </div>
                        {teamsError &&
                            <div className="error" style={{ marginTop: "5px", marginBottom: "5px" }}>
                                Please enter a valid email
                            </div>
                        }
                        {teamsSuccess &&
                            <div className="success" style={{ marginTop: "5px", marginBottom: "-10px" }}>
                                You're on the list!
                            </div>
                        }
                        
                        <div style={{ textAlign: "left", marginTop: "0px" }}>
                            <input className="form-control" placeholder="Enter email address"
                                value={teamsEmail} 
                                onChange={(e) => handleEmailChangeTeams(e)} />
                        </div>
                        
                        <button className="blueButton" onClick={(e) => handleJoinTeamsWaitlist(e)} 
                            onKeyDown={(e) => handleJoinTeamsWaitlist(e)}>
                            Join the Waitlist
                        </button> 
                        <button className="blueButton" onClick={(e) => handleRegister(e, "teams")} onKeyDown={(e) => handleRegister(e, "teams")}>
                            Try for free
                        </button> 
                        
                        <div style={{ fontSize: ".9em", textAlign: "center", marginLeft: "10px", 
                            color: "#495866", fontWeight: "500" }}>
                            14-day free trial <br/> No credit card needed
                        </div>
                        <hr className="pricingDivider" style={{ marginTop: "0px" }} />
                        <div style={{ textAlign: "left" }}>
                            <div style={{ marginBottom: "10px" }}>
                                <div style={{ display: "inline-block", marginRight: "10px" }}>
                                    <IoMdCheckmarkCircleOutline size={20} color="green" />
                                </div>
                                <div style={{ position: "relative", top: "2px", fontSize: "13pt", display: "inline-block" }}>
                                    {plan3.features[0]}
                                </div>
                            </div>
                            <div style={{ marginBottom: "10px" }}>
                                <div style={{ display: "inline-block", marginRight: "10px" }}>
                                    <IoMdCheckmarkCircleOutline size={20} color="green" />
                                </div>
                                <div style={{ position: "relative", top: "2px", fontSize: "13pt", display: "inline-block" }}>
                                {plan3.features[1]}
                                </div>
                            </div>
                            <div style={{ marginBottom: "10px" }}>
                                <div style={{ display: "inline-block", marginRight: "10px" }}>
                                    <IoMdCheckmarkCircleOutline size={20} color="green" />
                                </div>
                                <div style={{ position: "relative", top: "2px", fontSize: "13pt", display: "inline-block" }}>
                                {plan3.features[2]}
                                </div>
                            </div>
                            <div style={{ marginBottom: "10px" }}>
                                <div style={{ display: "inline-block", marginRight: "10px" }}>
                                    <IoMdCheckmarkCircleOutline size={20} />
                                </div>
                                <div style={{ position: "relative", top: "2px", fontSize: "13pt", display: "inline-block" }}>
                                {plan3.features[3]}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                */}
            </div>
            );
        } else {
            return <div>Whoops, we have no pricing!</div>
        }
    }
}

export default PricingTiers;